import * as React from 'react'
import { useLocation } from 'react-router-dom'

import { useCurrentSession } from 'modules/core/hooks/useCurrentSession'

import { ResponsivePage } from 'modules/layout/components/ResponsivePage'
import NuvoImporter from 'modules/universal_importer/components/NuvoImporter'
import type { Metadata } from 'modules/universal_importer/components/NuvoImporter/types'

type LocationStateType = {
  employeesIds?: number[]
  legalEntityId?: number
} | null

const TerminateInBulkPage = () => {
  const {
    company,
    access: { locale },
  } = useCurrentSession()
  const location = useLocation()
  const state: LocationStateType = location.state
  const employeesIds = React.useMemo(() => state?.employeesIds ?? [], [state?.employeesIds])
  const legalEntityId = state?.legalEntityId

  const metadata = React.useMemo<Metadata>(
    () => ({
      employee_ids: employeesIds,
      ...(legalEntityId ? { legal_entity_ids: [legalEntityId] } : {}),
    }),
    [employeesIds, legalEntityId]
  )

  return (
    <ResponsivePage.Body>
      <NuvoImporter
        importType="employee_bulk_termination_importer"
        locale={locale}
        companyId={company.id}
        metadata={metadata}
        isEdition
      />
    </ResponsivePage.Body>
  )
}

export default TerminateInBulkPage
